import List from '../Result.List.i18n';
import Detail from '../Result.Detail.i18n';

export default {
  components: { List, Detail},
  data: () => ({ base: false, list: false, detail: false, detail: false }),
  methods: {
    refresh() { if(this.$refs.list) { this.$refs.list.refresh(); } },
    select({ id, tag }) {
      if(!id) { this.base = this.list = !(this.detail = this.detail = false); }
      else if(id === 'add' || tag === 'detail') { this.detail = !(this.detail = this.list = false); }
      else { this.detail = !(this.list = this.detail = false); }
    }
  },
  created: function() {   console.log('Result.vue', 'created'); },
  destroyed: function() { console.log('Result.vue', 'destroyed'); },
  mounted: function() {
    console.log('Result.vue', 'mounted');
    this.select(this.$route.params);
  },
  watch: {
    '$route' (to, from) {
      console.log('Result.vue', 'route changed', to.param);
      this.select(to.params);
    }
  },
}
